import { type ComponentRef, Directive, input, output, type Type } from '@angular/core';
import { outputToObservable } from '@angular/core/rxjs-interop';
import { ContextMenuDirective } from '@frontendlib/components/features/popover/directives/context-menu.directive';
import type { FormFolderSummaryDto, FormSummaryDto } from '@sharedlib/dtos/dto/forms-app/form.dto';
import { takeUntil } from 'rxjs';
import { FormsSidebarContextMenuComponent } from './forms-sidebar-context-menu.component';
/** BoardsSidebarContextMenuDirective, with only the Forms owner and created-item bindings adapted. */
@Directive({ selector: '[appFormsSidebarContextMenu]', standalone: true })
export class FormsSidebarContextMenuDirective extends ContextMenuDirective {
  public readonly appFormsSidebarContextMenu = input.required<string>();
  public readonly appFormsSidebarContextMenuFormCreated = output<FormSummaryDto>();
  public readonly appFormsSidebarContextMenuFolderCreated = output<FormFolderSummaryDto>();
  protected registerComponent(): Type<FormsSidebarContextMenuComponent> {
    return FormsSidebarContextMenuComponent;
  }
  protected registerInstance(ref: ComponentRef<FormsSidebarContextMenuComponent>): void {
    ref.setInput('view', this.appFormsSidebarContextMenu());
    outputToObservable(ref.instance.formCreated)
      .pipe(takeUntil(this.alive))
      .subscribe((item) => this.appFormsSidebarContextMenuFormCreated.emit(item));
    outputToObservable(ref.instance.folderCreated)
      .pipe(takeUntil(this.alive))
      .subscribe((item) => this.appFormsSidebarContextMenuFolderCreated.emit(item));
  }
}
